module.exports = __webpack_public_path__ + "fonts/Jost-600-Semi.58e6b98.otf";